export const Laboratory = () => [
  { Name: "All Laboratories", Id: 0 },
  { Name: "CMS Brisbane", Id: 1 },
  { Name: "CMS Perth", Id: 2 },
  { Name: "CMS Newcastle", Id: 3 },
];
export default Laboratory;
